// extracted by mini-css-extract-plugin
module.exports = {"footerlink":"footer_footerlink__Yz6oh","footer":"footer_footer__1lZIc"};